import React from 'react';
import Styles from './ToyotaYarus.module.css';
import Carousel from '../../../../components/Carousel/Carousel';
import {cars} from './Data';

import Hero from '../HeroForm/Hero';







const ToyotaYarus = () => {
  return (
   
    <div className={Styles.main_page}>
      <h2>Toyota Yaris</h2>
      {/*Carousel*/}
      <div className={Styles.car_image}>
      <Carousel images={cars} />
      </div>
      

     <Hero selectedCar="Toyota Yaris" /> 

    </div>



  );
}

export default ToyotaYarus;